export const investorsContentRu = {
  mainTitle: 'Строительство, реконструкция студенческих общежитий: механизм размещения госзаказа',
  stats: [
    { value: '12 мес.', label: 'Поправочный коэффициент', sub: 'Проживающие ×2, но не более проектной мощности' },
    { value: '195 МРП', label: 'Все регионы (после 2023)', sub: 'Норматив строительства общежитий' },
    { value: '122 МРП', label: 'Все регионы (до 2023)', sub: 'Норматив строительства общежитий' },
    { value: '230 МРП', label: 'г. Алматы (после 2023)', sub: 'Повышенный региональный норматив' },
  ],
  tab0: {
    conditionLabel: 'Условие',
    category: 'Проект',
    disclosure:
      'Первые 12 месяцев госзаказ выплачивается с учетом поправочного коэффициента: количество проживающих студентов умножается на 2, но не более проектной мощности.',
    cards: [
      { tag: 'Выплаты', title: 'Фактически занятые места', text: 'Выплаты производятся за фактически занятые места в общежитии, но не выше проектной мощности.' },
      {
        tag: 'Сроки госзаказа',
        title: 'Период размещения',
        text1: 'Строительство:',
        text1strong: 'размещение госзаказа в течение 6 лет после ввода объекта в эксплуатацию.',
        text2: 'Реконструкция:',
        text2strong: 'размещение госзаказа в течение 8 лет после ввода объекта в эксплуатацию.',
      },
      {
        tag: 'Финансирование',
        title: 'Собственные средства застройщика',
        text: 'Реализация строительства / реконструкции осуществляется за счёт собственных средств застройщика.',
      },
    ],
  },
  tab1: {
    tableHead: ['Сценарий', 'Норматив', 'Применение'],
    rows: [
      ['Все регионы, объекты введены после 2023', '195 МРП', 'Строительство общежитий'],
      ['Все регионы, объекты введены до 2023', '122 МРП', 'Строительство общежитий'],
      ['г. Алматы, объекты введены до 2023', '144 МРП', 'Строительство общежитий'],
      ['г. Алматы, объекты введены после 2023', '230 МРП', 'Строительство общежитий'],
    ],
  },
  tab2: {
    steps: [
      'Подача заявления в АО «Финансовый центр» с правоустанавливающими и идентификационными документами.',
      'Подписание предварительного трехстороннего договора (ФЦ, уполномоченный орган, предприниматель).',
      'Проведение строительно-монтажных работ и ввод объекта в эксплуатацию.',
      'Заключение и регистрация соглашения обременения на 20 лет.',
      'Заключение трехстороннего договора госзаказа на выплаты.',
    ],
    stepLabel: 'Шаг',
    note: 'Алгоритм размещения госзаказа приведен по официальной странице проекта общежитий.',
  },
  tab3: {
    support: [
      { title: 'Банк ПСД', desc: 'Доступ к проектной документации и сопутствующим материалам по проектам.' },
      { title: 'Нормативные правовые акты', desc: 'Актуальные НПА и регламентирующие документы по механизму.' },
      { title: 'Часто задаваемые вопросы', desc: 'Разъяснения по процедурам размещения и выплатам госзаказа.' },
    ],
    supportSection: 'Раздел поддержки',
    description: 'Описание',
  },
  calc: {
    title: 'Калькулятор выплат по госзаказу',
    territory: 'Территориальная принадлежность',
    volumeLabel: 'Расчет объема подушевого финансирования строительства общежитий',
    places: 'мест',
    resultTitle: 'Расчёт:',
    yearMrp: 'МРП года',
    tableHead: ['Год', 'МРП (₸)', 'Норматив', 'Выплата за год'],
    total: 'Итого за 2025-2030',
    scenarios: [
      { id: 'all_after', label: 'Все регионы, после 2023', mrpRate: 195 },
      { id: 'all_before', label: 'Все регионы, до 2023', mrpRate: 122 },
      { id: 'almaty_before', label: 'г. Алматы, до 2023', mrpRate: 144 },
      { id: 'almaty_after', label: 'г. Алматы, после 2023', mrpRate: 230 },
    ],
    mrpSuffix: 'МРП',
  },
};

export const investorsContentKz = {
  mainTitle: 'Студенттік жатақханаларды салу, реконструкциялау: мемлекеттік тапсырысты орналастыру механизмі',
  stats: [
    { value: '12 ай', label: 'Түзету коэффициенті', sub: 'Тұратындар ×2, бірақ жобалық қуаттан аспайды' },
    { value: '195 АЕК', label: 'Барлық өңір (2023 кейін)', sub: 'Жатақхана салу нормативі' },
    { value: '122 АЕК', label: 'Барлық өңір (2023 дейін)', sub: 'Жатақхана салу нормативі' },
    { value: '230 АЕК', label: 'Алматы қ. (2023 кейін)', sub: 'Өңірлік жоғарылатылған норматив' },
  ],
  tab0: {
    conditionLabel: 'Шарт',
    category: 'Жоба',
    disclosure:
      'Алғашқы 12 айда мемлекеттік тапсырыс түзету коэффициенті ескеріледі: тұратын студенттер саны 2-ге көбейтіледі, бірақ жобалық қуаттан аспайды.',
    cards: [
      { tag: 'Төлемдер', title: 'Нақты бос емес орындар', text: 'Төлемдер жатақханадағы нақты бос емес орындар үшін жүргізіледі, бірақ жобалық қуаттан жоғары емес.' },
      {
        tag: 'МТ мерзімдері',
        title: 'Орналастыру кезеңі',
        text1: 'Салу:',
        text1strong: 'объект пайдалануға берілгеннен кейін 6 жыл ішінде МТ орналастыру.',
        text2: 'Реконструкция:',
        text2strong: 'объект пайдалануға берілгеннен кейін 8 жыл ішінде МТ орналастыру.',
      },
      {
        tag: 'Қаржыландыру',
        title: 'Құрылысшының өз қаражаты',
        text: 'Салу / реконструкциялау құрылысшының өз қаражаты есебінен жүзеге асырылады.',
      },
    ],
  },
  tab1: {
    tableHead: ['Сценарий', 'Норматив', 'Қолдану'],
    rows: [
      ['Барлық өңір, объектілер 2023 кейін енгізілген', '195 АЕК', 'Жатақхана салу'],
      ['Барлық өңір, объектілер 2023 дейін енгізілген', '122 АЕК', 'Жатақхана салу'],
      ['Алматы қ., объектілер 2023 дейін енгізілген', '144 АЕК', 'Жатақхана салу'],
      ['Алматы қ., объектілер 2023 кейін енгізілген', '230 АЕК', 'Жатақхана салу'],
    ],
  },
  tab2: {
    steps: [
      '«Қаржы орталығы» АҚ-ға құқық белгілейтін және сәйкестендіру құжаттарымен өтінім беру.',
      'Алдын ала үшжақты шартқа қол қою (ҚО, уәкілетті орган, кәсіпкер).',
      'Құрылыс-монтаж жұмыстарын жүргізу және объектіні пайдалануға беру.',
      '20 жылға ауыртпалық келісімін жасасу және тіркеу.',
      'Төлемдер бойынша үшжақты МТ шартын жасасу.',
    ],
    stepLabel: 'Қадам',
    note: 'МТ орналастыру алгоритмі жатақхана жобасының ресми беті бойынша келтірілген.',
  },
  tab3: {
    support: [
      { title: 'Жоба құжаттамасы банкі', desc: 'Жобалар бойынша жобалық құжаттамаға және қосымша материалдарға қол жеткізу.' },
      { title: 'Нормативтік құқықтық актілер', desc: 'Механизм бойынша өзекті НҚА және регламенттік құжаттар.' },
      { title: 'Жиі қойылатын сұрақтар', desc: 'Орналастыру рәсімдері мен МТ төлемдері бойынша түсіндірмелер.' },
    ],
    supportSection: 'Қолдау бөлімі',
    description: 'Сипаттама',
  },
  calc: {
    title: 'МТ бойынша төлемдер калькуляторы',
    territory: 'Аумақтық тиесілілік',
    volumeLabel: 'Жатақхана салуды жан басына қаржыландыру көлемін есептеу',
    places: 'орын',
    resultTitle: 'Есеп:',
    yearMrp: 'АЕК жылы',
    tableHead: ['Жыл', 'АЕК (₸)', 'Норматив', 'Жылдық төлем'],
    total: '2025-2030 барлығы',
    scenarios: [
      { id: 'all_after', label: 'Барлық өңір, 2023 кейін', mrpRate: 195 },
      { id: 'all_before', label: 'Барлық өңір, 2023 дейін', mrpRate: 122 },
      { id: 'almaty_before', label: 'Алматы қ., 2023 дейін', mrpRate: 144 },
      { id: 'almaty_after', label: 'Алматы қ., 2023 кейін', mrpRate: 230 },
    ],
    mrpSuffix: 'АЕК',
  },
};
